import React, { useState } from "react";
import Header from "../../component/Header";
import Sidebar from "../../component/SideBar";
import { ToastContainer, toast } from "react-toastify";
import { Visibility, VisibilityOff, Lock } from '@mui/icons-material';
import {
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  CircularProgress
} from '@mui/material';
import Apiconnection from "../../utils/Apiconnection";
import Loader from "../../utils/Loader";
import { image } from "../../common/Theme";

const ChangePassword = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  });

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!oldPassword) {
      newErrors.oldPassword = "Old password is required";
    }
    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters long";
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setLoading(true);
    const payload = {
      old_password: oldPassword,
      password: newPassword,
      platform: "AdminPanel",
      deviceType: 2
    };

    try {
      const response = await Apiconnection.post("change-password", payload);

      if (response?.data?.status) {
        toast.success(response?.data?.message || "Password changed successfully");
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error(response?.data?.message || "Failed to change password");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Pr!@me@2026


  return (
    <div className="grid-container">
      <ToastContainer />
      {loading && <Loader />}
      <Header OpenSidebar={OpenSidebar} />
      <Sidebar
        openSidebarToggle={openSidebarToggle}
        OpenSidebar={OpenSidebar}
      />
      <Box component="main" className="main-container" sx={{ flexGrow: 1, p: 3, display: 'flex', flexDirection: 'column' }}>
        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '80vh' }}>
          <Grid item xs={12} sm={8} md={6} lg={5}>
            <Card sx={{ borderRadius: '15px', boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)', overflow: 'visible' }}>
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 600, mb: 4, color: '#333' }}>
                  Change Password
                </Typography>

                <form onSubmit={handleSubmit}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <TextField
                      fullWidth
                      label="Old Password"
                      type={showOldPassword ? "text" : "password"}
                      variant="outlined"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      error={!!errors.oldPassword}
                      helperText={errors.oldPassword}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock sx={{ color: '#13D3A9' }} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowOldPassword(!showOldPassword)} edge="end">
                              {showOldPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />

                    <TextField
                      fullWidth
                      label="New Password"
                      type={showNewPassword ? "text" : "password"}
                      variant="outlined"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      error={!!errors.newPassword}
                      helperText={errors.newPassword}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock sx={{ color: '#13D3A9' }} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end">
                              {showNewPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />

                    <TextField
                      fullWidth
                      label="Confirm New Password"
                      type={showConfirmPassword ? "text" : "password"}
                      variant="outlined"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      error={!!errors.confirmPassword}
                      helperText={errors.confirmPassword}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock sx={{ color: '#13D3A9' }} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                              {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />

                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      disabled={loading}
                      sx={{
                        mt: 2,
                        py: 1.5,
                        backgroundColor: '#13D3A9',
                        borderRadius: '10px',
                        textTransform: 'none',
                        fontSize: '16px',
                        fontWeight: 600,
                        '&:hover': {
                          backgroundColor: '#00008d',
                        }
                      }}
                    >
                      {loading ? <CircularProgress size={24} color="inherit" /> : "Update Password"}
                    </Button>
                  </Box>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default ChangePassword;
